<template>
  <v-menu max-width="180" offset-y transition="scale-transition">
    <template v-slot:activator="{ on, attrs, value }">
      <div v-bind="attrs" v-on="on" @click="$emit('click', value)" v-if="showHelpText">
        <v-btn rounded fab :color="btnColor" small depressed :class="btnClass"
          ><v-icon :color="iconColor">mdi-plus</v-icon></v-btn
        ><span class="text--secondary text-caption ml-2 cursor-pointer">Start adding a heading or a link</span>
      </div>
      <v-btn
        v-else
        v-bind="attrs"
        v-on="on"
        @click="$emit('click', value)"
        rounded
        fab
        :color="btnColor"
        x-small
        depressed
        :class="btnClass"
        ><v-icon :color="iconColor">mdi-plus</v-icon></v-btn
      >
    </template>
    <v-list nav>
      <v-list-item @click="$emit('addHeading')">
        <v-list-item-title>Add new heading</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('addLink')">
        <v-list-item-title>Add new link</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    btnClass: {
      type: Array,
      default: function() {
        return [];
      },
    },
    showHelpText: { type: Boolean, default: false },
    iconColor: { type: String, default: "" },
    btnColor: { type: String, default: "primary" },
  },
};
</script>

<style></style>
